module.exports = __webpack_public_path__ + "static/media/Minion3-Regular.2919fa0d.svg";